import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getFormEditorFormService,
  getFormEditorTextractFieldsService,
} from '../../services/getFormEditorService';
import { getSignedPdfUrlService } from '../../services/getSignedPdfSignedUrlService';
import { putPdfFileToS3Service } from '../../services/putPdfFileToS3Service';
import { saveFormEditorFormService } from '../../services/saveFormEditorServices';
import { updateFormEditorFormService } from '../../services/updateFormEditorService';
import { getSelectedFormEditorFormForDynamoDB } from '../slices/formEditorSlice';
import { getEmployerBusinessesService } from '../../services/getEmployerBusinessesService';
import { copyFormEditorFormService } from '../../services/copyFormEditorFormService';
import { v4 } from 'uuid';
import { deleteFormEditorFormService } from '../../services/deleteFormEditorFormService';

export const getFormEditorFormThunk = createAsyncThunk(
  'formEditor/getFormEditor',
  async (payload, { getState, rejectWithValue }) => {
    try {
      const response = await getFormEditorFormService();

      return response;
    } catch (error) {
      return rejectWithValue('Failed to add NEW UNIT data');
    }
  }
);

export const getFormEditorTextTractDataThunk = createAsyncThunk(
  'formEditor/getFormEditorTextTractData',
  async (s3Key, { getState, rejectWithValue }) => {
    try {
      const response = await getFormEditorTextractFieldsService(s3Key);

      return response;
    } catch (error) {
      return rejectWithValue('Failed to add NEW UNIT data');
    }
  }
);

// happens When pdf is first loaded/selected
export const saveFormEditorFormThunk = createAsyncThunk(
  'formEditor/saveFormEditor',
  async (
    { formEditorFormDraft, fileIds, fileBinaryArray },
    { getState, rejectWithValue }
  ) => {
    try {
      // GET SIGNED URL
      console.log('got signed url');

      // UPLOAD FILE
      const keys = [];
      for (let i = 0; i < fileBinaryArray.length; i++) {
        const { signedUrl, key } = await getSignedPdfUrlService(fileIds[i]);
        keys.push(key);

        await putPdfFileToS3Service(signedUrl, fileBinaryArray[i]);
      }
      console.log('uploaded to s3');

      // SAVE TO DB
      console.log('KEYS', keys);
      const response = await saveFormEditorFormService(
        formEditorFormDraft,
        keys
      );

      console.log('saved to dynamodb');

      return response;
    } catch (error) {
      return rejectWithValue('Failed to add NEW');
    }
  }
);

export const copyFormEditorFormThunk = createAsyncThunk(
  'formEditor/copyFormEditor',
  async ({ formEditorForm }, { getState, rejectWithValue }) => {
    try {
      console.log('FORMEDITORFORM', formEditorForm);
      // SAVE TO DB
      const formCopy = {
        ...formEditorForm,
        id: v4(),
        name: `${formEditorForm.name} kopio`,
      };
      console.log('FORMCOPY', formCopy);

      const response = await copyFormEditorFormService(formCopy);

      console.log('saved to dynamodb');

      return response;
    } catch (error) {
      return rejectWithValue('Failed to add NEW');
    }
  }
);

export const deleteFormEditorFormThunk = createAsyncThunk(
  'formEditor/deleteFormEditor',
  async ({ formEditorFormId }, { getState, rejectWithValue }) => {
    try {
      const response = await deleteFormEditorFormService(formEditorFormId);

      return response;
    } catch (error) {
      return rejectWithValue('Failed to add NEW');
    }
  }
);

export const updateFormEditorFormThunk = createAsyncThunk(
  'formEditor/updateFormEditor',
  async (payload, { getState, rejectWithValue }) => {
    console.log('updateFormEditorFormThunk');

    const state = getState();

    const fullModifiedItem = getSelectedFormEditorFormForDynamoDB(state);

    console.log('UPDATED ITEM', fullModifiedItem);

    try {
      const response = await updateFormEditorFormService(fullModifiedItem);

      return response;
    } catch (error) {
      console.log('failed to update');

      return rejectWithValue('Failed to update');
    }
  }
);

export const getEmployerBusinessesThunk = createAsyncThunk(
  'formEditor/getEmployerBusinesses',
  async (payload, { getState, rejectWithValue }) => {
    console.log('getEmployerBusinessesThunk');

    try {
      const response = await getEmployerBusinessesService();
      console.log('EMPLOYER RESPONSE', response);
      return response;
    } catch (error) {
      return rejectWithValue('Failed to add NEW UNIT data');
    }
  }
);
